export default __webpack_public_path__ + "static/media/background.55e7fb48.jpg";